<template>
  <main class="wrap-content" :class="$route.name">
    <div class="artwork-list">
      <div class="grid" id="main-grid" v-if="userAccount">
        <artwork-item
          :artwork="artwork"
          :isOnline="isOn(artwork.key)"
          :key="artwork.key"
          :uri="'/artwork/' + artwork.key"
          @requirePlay="openPlayerPopup"
          v-for="artwork in artworks"/>
        <router-link class="grid-cell button frameless" title="Add Artwork" to="/account/artwork/new">
          <i class="plus large"/>
        </router-link>
      </div>
      <div class="popup dark" v-if="playerControllerOn" id="popup-player-controller">
        <display-controller :artwork="artworkForPlayerController" @play="play" />
        <button @click="closePopup" class="close top right frameless secondary">
          <i class="close"/>
        </button>
      </div>
      <div class="shade" v-if="playerControllerOn"></div>
    </div>
  </main>
</template>

<script>
import firebase from '../../firebase-app'
import { mapActions, mapState } from 'vuex'
import { Artwork } from '../../models/ArtworkData'
import { Player } from '../../models/Player'
import ArtworkItem from '../elements/ArtworkItem'
import DisplayController from '../account/DisplaySetupController'
import { PlayerArtwork } from '../../models/PlayerArtwork'
import { log } from '../../helper'

export default {
  components: {
    ArtworkItem,
    DisplayController
  },

  data () {
    return {
      playerControllerOn: false,
      artworkForPlayerController: null
    }
  },

  created () {
    this.init()
  },
  computed: {
    ...mapState(['userAccount', 'accountArtworks', 'accountPlayers']),

    accountId () {
      if (!this.userAccount) {
        return null
      }
      return this.userAccount['.key']
    },
    artworks () {
      if (this.accountArtworks) {
        return this.accountArtworks.map(it => Artwork.fromJson(it))
      }
      return []
    }
  },
  methods: {
    ...mapActions(['setRef']),

    init () {
      if (this.accountId) {
        this.setRef({
          key: 'accountArtworks',
          ref: firebase.database().ref('accounts/' + this.accountId + '/artworks')
        })
        this.setRef({
          key: 'accountPlayers',
          ref: firebase.database().ref('accounts/' + this.accountId + '/players')
        })
      }
    },

    play (setupIndex, { configId, channelPlayers }) {
      if (!this.accountId || !this.artworkForPlayerController) {
        return
      }
      const artwork = this.artworkForPlayerController
      channelPlayers.forEach((playerId, i) => {
        const path = `accounts/${this.accountId}/players/${playerId}/artwork/`
        const values = PlayerArtwork.fromArtwork(artwork.key, artwork, configId, i, setupIndex).toUpdates(path, PlayerArtwork.empty())
        firebase.database().ref(path).remove()
          .then(() => firebase.database().ref().update(values))
          .catch(log)
      })
      // this.playerControllerOn = false
    },

    openPlayerPopup (artwork) {
      this.artworkForPlayerController = artwork
      this.openPopup()
    },

    isOn (artworkId) {
      if (this.accountPlayers) {
        return this.accountPlayers
          .map(player => Player.fromJson(player))
          .filter(player => player.connected && player.isArtworkLaunched(artworkId))
          .length > 0
      }
    },

    openPopup () {
      this.playerControllerOn = true
      document.body.classList.add('no-scroll')
    },
    closePopup () {
      this.playerControllerOn = false
      document.body.classList.remove('no-scroll')
    }
  },
  watch: {
    $route () {
      this.init()
    },
    'userAccount' () {
      this.init()
    }
  }
}
</script>

<style lang="scss">
  @import "../../scss/vars";

  .popup {
    position: fixed;
    /*display: inline-block;*/
    z-index: 10001;
    top: $basic-size;
    left: 50%;
    max-width: calc(100vw - #{$basic-size});
    width: $basic-size * 13;
    max-height: calc(100vh - #{$basic-size * 2});
    overflow-y: auto;
    overflow-x: visible;

    transform: translateX(-50%);
    padding: $two-thirds;
    background: #fff;

    transition: height 0.1s;

    &.dark {
      background: $px-color-grey;
      color: #fff;
    }

    button.close {
      /*positi;*/
    }
  }

  .shade {
    content: '';
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 10000;
    background: rgba(60, 60, 60, 0.85);
    pointer-events: none;
  }
</style>
